import PersonalForm from "./PersonalForm";
import Contact from "./Contact";
import UserWork from "./UserWork";
import UserAvailability from "./UserAvailability";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import Cookies from "js-cookie";
import { FaArrowRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import CustomTable from "../../../Components/Common/CustomTable";
import { UserFrom } from "./UserData";
import {
  clearError,
  clearSingleUser,
  clearUsersError,
  createProfile,
  editProfile,
  getProfiles,
  getSingleProfile,
} from "../../../redux/users/userSlice";
import UserTd from "./UserTd";
import UserteHeader from "./UserteHeader";
import Loading from "../../../Components/Common/Loading";
import toast from "react-hot-toast";
import { FiUserX } from "react-icons/fi";
import Loader from "../../../Components/Common/Loader";
const initialFormState = {
  PersonalData: {firstName: "",lastName: "",dateOfBirth: "",gender: "",dialCode: "+91",phoneNumber: "",email: "",userType: "practitioner",imageUrl:""},
  ContactData: {Address1: "",Address2: "",country: "",state: "",city: "",zipCode: ""},
  WorkData: {designation: "",speciality: "",experience: "",licenseNumber: "",hprId: "",reenterHprId: "",about: "",qualification: "",online: "",inPerson: ""},
  Availability: [],
};

const tabHeaders = ["Personal", "Contact", "Work", "Availability"];
const itemsPerPage = 5;

const User = ({ showForm, toggleCreateProviderForm }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ProId = searchParams.get("ProId");

  // State management
  const [activeTab, setActiveTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState("createdAt");
  const [order, setOrder] = useState("desc");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [formData, setFormData] = useState(initialFormState);

  // Selectors
  const { locations } = useSelector((state) => state.locations);
  const { totalPages,singleUser,error,users,isLoading} = useSelector((state) => state.users);
  const { profileData } = useSelector((state) => state.profile);

 // Data fetching
  useEffect(() => {
    if (!showForm) {
      dispatch(getProfiles({ currentPage, sortBy, order, itemsPerPage,userType: "practitioner" }));
    }
  }, [dispatch, currentPage, sortBy, order, showForm]);
 
  useEffect(() => {
    if (error) {
      toast.error(error);
      setTimeout(() => {
        dispatch(clearUsersError());
      }, 2000);
    }
  }, [error]);


  useEffect(() => {
    if (ProId) dispatch(getSingleProfile(ProId));
  }, [ProId, dispatch]);

 
  function handleSortField(field) {
    setSortBy(field)
  }
  function handleSortOrder(order) {
    setOrder(order)
  }
  // Form initialization
  useEffect(() => {
    if (!singleUser) return;
 
    const { address = {}, work = {}, phoneNumber = {} , locations=[],firstName,lastName,dob,gender,email,imageUrl} = singleUser;
    const{addressLine1,addressLine2,...rest} = address
    setFormData({
      PersonalData: {
        ...initialFormState.PersonalData,
        firstName,lastName,
        gender,email,
        dateOfBirth: singleUser.dob
          ? format(new Date(singleUser.dob), "yyyy-MM-dd")
          : "",
        dialCode: phoneNumber?.dialCode || "+91",
        phoneNumber: phoneNumber?.value || "",
        imageUrl
      },
     
      ContactData: { ...initialFormState.ContactData, Address1: address.addressLine1,
      Address2: address.addressLine2, ...rest},
      WorkData: {
        ...initialFormState.WorkData,
        ...work,
        reenterHprId: work.hprId || "",
      },
      Availability:locations
    });
 
  }, [singleUser]);

  // Form submission
  // In User.jsx, modify the handleProfileSubmit function:

const handleProfileSubmit = useCallback(async () => {
 
  try {
    const locationsId = selectedLocations
      .filter((loc) => loc.isSelected)
      .map((loc) => loc.id);
    // A practitioner with no location cannot be rostered or booked anywhere.
    if (!locationsId.length) {
      toast.error("Please select at least one location for this practitioner.");
      return;
    }

    const body = {
      locations: locationsId.length ? locationsId : [],
    };
      await dispatch(
        editProfile({
          body,
          id: singleUser._id,
          userId: singleUser?.userId,
        })
      ).unwrap();
 
    toast.success(ProId ? "Profile updated successfully!" : "Profile created successfully!");
    navigate("/iam/users");
    toggleCreateProviderForm();
    setFormData(initialFormState);
  } catch (error) {
    console.error("Profile submission error:", error);
    toast.error(error?.message || "An error occurred while saving the profile");
  }
}, [
  ProId, 
  dispatch, 
  selectedLocations, 
  profileData, 
  formData,  // Add formData to dependencies
  navigate,  // Add navigate to dependencies
  toggleCreateProviderForm, 
  singleUser
]);


 
  useEffect(() => {
    if (!showForm) {
      setActiveTab(0);
      setFormData(initialFormState);
      dispatch(clearSingleUser());
    }
  }, [showForm, dispatch]);

  useEffect(() => () => dispatch(clearSingleUser()), [dispatch]);


  // Tab rendering
  const renderTabs = useCallback(
    () => (
      <div className="flex gap-1 border-b-2 border-gray-300  h-22 sticky top-0 bg-white z-10 p-2">
        {tabHeaders.map((header, index) => (
          <React.Fragment key={index}>
            <button
              className={`py-2 px-6 rounded-t-md cursor-pointer transition-all duration-300 ease-in-out 
              ${
                activeTab === index
                  ? "bg-white text-brand-500 border-b-4 border-brand-500 font-semibold shadow-sm"
                  : "bg-transparent text-gray-600 hover:bg-gray-100 border-b-2 border-transparent hover:border-gray-300"
              }`}
              onClick={() => setActiveTab(index)}
              aria-pressed={activeTab === index ? "true" : "false"}
            >
              {header}
            </button>
            {index < tabHeaders.length - 1 && (
              <FaArrowRight
                className="text-brand-500 text-lg py-2 mx-2 self-center"
                size={30}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    ),
    [activeTab]
  );
 
  // Form rendering
  const renderFormSection = () => {
    const commonProps = {
      formData,
      setFormData,
      setActiveTab,
      handleSubmit: handleProfileSubmit,
      userType: formData.PersonalData.userType,
    };

    switch (activeTab) {
      case 0:
        return (
          <PersonalForm
            {...commonProps}
            PersonalDataForm={UserFrom.PersonalData}
            PersonalDataState={formData.PersonalData}
            ProId={ProId}
          />
        );
      case 1:
        return (
          <Contact
            {...commonProps}
            ContactDataForm={UserFrom.ContactData}
            ContactDataState={formData.ContactData}
          />
        );
      case 2:
        return (
          <UserWork
            {...commonProps}
            WorkDataStateForm={UserFrom.WorkData}
            WorkDataState={formData.WorkData}
            ProId={ProId}
          />
        );
      case 3:
        return (
          <UserAvailability
            locations={locations}
            selectedLocations={selectedLocations}
            userLocations={formData.Availability}
            setSelectedLocations={setSelectedLocations}
            handleUserAvailability={handleProfileSubmit}
          />
        );
      default:
        return null;
    }
  };

 

  return showForm ? (
    <div className="h-full customScrollbar pb-18 ">
      {renderTabs()}
      {renderFormSection()}
    </div>
  ) : isLoading ? (
    <Loader />
  ) : (
    <div className="overflow-x-auto sm:rounded-lg h-full">
      { users.length>0 ? (
        <>
          <CustomTable 
            trHeader={
              <UserteHeader setSortBy={handleSortField} setOrder={handleSortOrder} sortBy={sortBy} order={order}/>
            }
          >
            <UserTd
              toggleCreateProviderForm={toggleCreateProviderForm}
            />
          </CustomTable>
          <ReactPaginate
            previousLabel="«"
            nextLabel="»"
            breakLabel="..."
            pageCount={totalPages}
            onPageChange={({ selected }) => setCurrentPage(selected + 1)}
            containerClassName={"flex justify-center mt-6 mb-0"}
            pageLinkClassName={
              "block px-4 py-2 rounded hover:bg-brand-600 hover:text-white"
            }
            previousClassName={"mx-1"}
            previousLinkClassName={
              "block px-3 py-2 rounded bg-slate-100 hover:bg-brand-600 hover:text-white"
            }
            nextClassName={"mx-1"}
            nextLinkClassName={
              "block px-3 py-2 rounded bg-slate-100 hover:bg-brand-600 hover:text-white"
            }
            activeClassName={"bg-brand-500 text-white rounded"}
            activeLinkClassName={"border-none"}
          />
        </>
      ) : (
        <div className="w-full h-full flex justify-center items-center">
                    <div className="flex flex-col items-center justify-center min-h-[300px] text-center p-6">
                      <FiUserX className="h-20 w-20 text-brand-500 mb-4" />
                      <h2 className="text-2xl font-semibold text-gray-700 mb-2">
                      No users found
                      </h2>
                      <p className="text-gray-500 mb-4">
                      Start by adding a new user
                      </p>
                    </div>
                  </div>
      )}
    </div>
  );
};

export default React.memo(User);
